import script from "./WhatYouGet.vue?vue&type=script&setup=true&lang=js"
export * from "./WhatYouGet.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__